// extracted by mini-css-extract-plugin
export default {"Content":"SocialNetworks_Content__5-0zi"};